// import React from 'react';
// import { Navigate } from 'react-router-dom';
// function ProtectedRoute({ children }) {
//   const token = localStorage.getItem('token');
//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }
//   return children;
// }
// export default ProtectedRoute;
import React from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/authHelper";
function ProtectedRoute({ children, permissionKey }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (role === "SUPER_ADMIN") {
    return children;
  }
  if (!permissionKey) {
    return children;
  }
  if (hasPermission(permissionKey)) {
    return children;
  }
  return <Navigate to="/" replace />;
}
export default ProtectedRoute;